import { Roles } from '@/core/types';
import useAuth from '@/shared/context/auth-context';
import { FunctionComponent, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import LeviantAdminLogsPage from './logs-index.page';

const LogsPage: FunctionComponent = (): ReactElement => {
	const { user } = useAuth();
	const { role } = user || {};

	if (role === Roles.LEVIANT_ADMIN) {
		return <LeviantAdminLogsPage />;
	}

	return <Navigate to="/" />;
};

export default LogsPage;
